module.exports = __webpack_public_path__ + "media/images/hortense-for-wedding/Groupe 101-dfe57fcb526d00aece4f02e9ff0de74b.png";